import React, { useEffect } from "react";
import { useAdmin } from "../../context/AdminContext";
import { useParams } from "react-router-dom";

const AdminDetail = () => {
  const { userID } = useParams();
  console.log("UserId", userID);
  const {
    userSessions,
    fetchUserSessions,
    exportUserSessionsCSV,
    exportUserSessionsExcel,
  } = useAdmin();
  useEffect(() => {
    fetchUserSessions(userID);
  }, [userID]);
  console.log("userSessions", userSessions);
  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "10px",
          margin: "10px",
          justifyContent: "right",
        }}
      >
        {/* <button className="rec-btn" onClick={handleSave}>
          Save Snapshot
        </button> */}

        <button
          className="rec-btn"
          onClick={() => exportUserSessionsCSV(userID)}
          // disabled={!isSaved}
        >
          Export CSV
        </button>

        <button
          className="rec-btn"
          onClick={() => exportUserSessionsExcel(userID)}
          // disabled={!isSaved}
        >
          Export Excel
        </button>
      </div>
      <table className="stock-table">
        <thead>
          <tr>
            <th>Login Time</th>
            <th>Logout Time</th>
            <th>IP Address</th>
            <th>Device</th>
          </tr>
        </thead>

        <tbody>
          {userSessions?.length > 0 ? (
            userSessions.map((session) => {
              const login = new Date(session.login_at);
              const logout = session.logout_at
                ? new Date(session.logout_at)
                : null;

              return (
                <tr key={session.id} className="stock-row">
                  {/* LOGIN */}
                  <td>{login.toLocaleString()}</td>

                  {/* LOGOUT */}
                  <td>{logout ? logout.toLocaleString() : "—"}</td>

                  {/* IP ADDRESS */}
                  <td>{session.IPAddress || "-"}</td>

                  {/* DEVICE */}
                  <td>{session.BrowserName || "-"}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="4" style={{ textAlign: "center" }}>
                No history found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default AdminDetail;
